export const magicWandMixin = {
  data() {
    return {
      wizardExamples: {},
      openExamplesField: null,
      wizardExamplesLoading: false,
      wizardExamplesLoaded: false
    };
  },
  computed: {
    magicWandAccentColor() {
      return (this.community && this.community.customSettings && this.community.customSettings.primaryBtnBgColor) || '#D13525';
    },
    magicWandThemeStyle() {
      return {
        '--magic-wand-accent': this.magicWandAccentColor
      };
    }
  },
  methods: {
    isMagicWandActive() {
      if (typeof this.enableMagicWandLF !== 'undefined') {
        return this.enableMagicWandLF;
      }
      if (typeof this.magicWandEnabled !== 'undefined') {
        return this.magicWandEnabled;
      }
      return false;
    },
    isExamplesOpen(field) {
      return this.openExamplesField === field;
    },
    getMagicWandQueryParams() {
      const circle = this.sourceparam || '';
      return `community=${this.community_id}${circle ? `&circle=${circle}` : ''}`;
    },
    extractWizardValues(response) {
      if (!response || !response.data) {
        return [];
      }
      const data = response.data;
      if (Array.isArray(data)) {
        return [];
      }
      if (data.values && Array.isArray(data.values)) {
        return data.values.filter(value => value && String(value).trim());
      }
      return [];
    },
    async loadWizardExamples(fieldConfig) {
      if (!this.isMagicWandActive() || this.wizardExamplesLoaded || this.wizardExamplesLoading) {
        return;
      }
      this.wizardExamplesLoading = true;
      try {
        const params = this.getMagicWandQueryParams();
        const results = await Promise.all(
          fieldConfig.map(({ field, key }) =>
            this.api
              .get(`configuration/customizations/${key}?${params}`)
              .then(response => ({
                field,
                values: this.extractWizardValues(response)
              }))
              .catch(() => ({ field, values: [] }))
          )
        );
        results.forEach(({ field, values }) => {
          this.$set(this.wizardExamples, field, values);
        });
        this.wizardExamplesLoaded = true;
      } finally {
        this.wizardExamplesLoading = false;
      }
    },
    async toggleMagicWandExamples(field) {
      if (!this.isMagicWandActive()) {
        return;
      }
      if (this.openExamplesField === field) {
        this.closeMagicWandExamples();
        return;
      }
      this.openExamplesField = field;
      if (!this.wizardExamplesLoaded) {
        await this.loadWizardExamples(this.magicWandFieldConfig);
      }
    },
    closeMagicWandExamples() {
      this.openExamplesField = null;
    },
    getWizardExamplesForField(field) {
      return this.wizardExamples[field] || [];
    },
    getMagicWandFieldLabel(field) {
      const config = this.magicWandFieldConfig.find(item => item.field === field);
      return config ? config.label : '';
    },
    magicWandFieldHasText(field) {
      const current = this.ask && this.ask[field];
      return !!(current && String(current).trim().length > 0);
    },
    insertMagicWandExample(field, exampleText) {
      // Confirmation (when the field already has text) is handled inline inside
      // MagicWandExamplesPanel, so by the time this runs the choice is final.
      this.$set(this.ask, field, exampleText);
      this.closeMagicWandExamples();
      if (typeof this.countdown === 'function') {
        if (this.countdown.length > 0) {
          this.countdown(field);
        } else {
          this.countdown();
        }
      }
      this.$nextTick(() => {
        const refMap = {
          subject: 'subjectMagicWand',
          bio: 'bioMagicWand',
          text: 'textMagicWand',
          closeNicely: 'closeNicelyMagicWand'
        };
        const refName = refMap[field] || 'questionPlaceholderRef';
        const ref = this.$refs[refName];
        if (ref) {
          ref.focus();
          ref.dispatchEvent(new Event('input'));
        }
      });
      if (typeof this.onMagicWandExampleInserted === 'function') {
        this.onMagicWandExampleInserted(field, exampleText);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/magicWandMixin.js